import { CouponsForLocalZipCodes } from '../../services/viva/constants';

import localZipCodes from './local-zipcodes.json';

const zipCodes = new Set(localZipCodes as number[]);

export function isLocalZipCode(zipCode: string): boolean {
  return zipCodes.has(parseInt(zipCode));
}

export function isLocalCoupon(coupon: string): boolean {
  return CouponsForLocalZipCodes.includes(coupon.toUpperCase());
}

export function isLocalZipRequiredForCoupon(
  zipCode: string,
  coupon: string,
): boolean {
  if (isLocalCoupon(coupon)) {
    if (isLocalZipCode(zipCode)) {
      return true;
    }
  }
  return false;
}
